import { FormlyFieldConfig } from '@ngx-formly/core';

export function requiredValidatorMessage(error: unknown, field: FormlyFieldConfig) {
  return 'This is a required field';
}

export function requiredTrueValidatorMessage(error: unknown, field: FormlyFieldConfig) {
  return 'This must be checked';
}
